var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-warpper"},[_c('header-bar',{attrs:{"firstName":_vm.firstName}}),_c('section',{staticClass:"app-main"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{key:_vm.key,on:{"tourist":_vm.tourist,"name":_vm.name,"header":_vm.header}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }